import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ComponentHostDirective } from './component-host.directive';

@NgModule({
  declarations: [
    ComponentHostDirective
  ],
  imports: [
    IonicModule,
    CommonModule
  ],
  exports: [
    ComponentHostDirective
  ]
})
export class ComponentHostDirectiveModule { }
